import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import SimpleInfoPopup from '../../common/SimpleInfoPopup';
import { selectCurrentAppointment } from '../../../redux/appointmnents/selectors';
import { redirectToHealthBoard, redirectToLogIn } from '../../../utils/appointments/redirect-utils';
import { appointmentDetailsActions } from '../../../redux/healthboard/appointment-details';
import { APPOINTMENT_STATUSES } from '../../../constants';
import { selectVideoCallEndPopup } from '../../../redux/ui/selectors';
import { videoCallEndPopupActions } from '../../../redux/ui/videoCallEndPopup';

import styles from './styles.styl';

function VideoCallEndPopup() {
  const dispatch = useDispatch();
  const [message, setMessage] = useState('');
  const appointment = useSelector(selectCurrentAppointment);
  const userId = get(appointment, 'userId');
  const popupState = useSelector(selectVideoCallEndPopup);
  const visible = get(popupState, 'visible');
  const status = get(popupState, 'status');

  const onPopupOpen = status => {
    switch (status) {
      case APPOINTMENT_STATUSES.NO_SHOW:
      case APPOINTMENT_STATUSES.CANCELED:
        setMessage('virtualVisit.canceledByProvider');
        break;
      case APPOINTMENT_STATUSES.COMPLETED:
        setMessage('virtualVisit.complete');
        break;
      default:
        return;
    }
  };

  const onPopupClose = () => {
    userId ? redirectToHealthBoard(userId) : redirectToLogIn();
    dispatch(appointmentDetailsActions.setAppointmentId(undefined));
    dispatch(appointmentDetailsActions.sliceUpcomingAppointment(appointment));
    dispatch(videoCallEndPopupActions.close());
  };

  useEffect(() => {
    onPopupOpen(status);
  }, [status]);

  return (
    <SimpleInfoPopup
      autoHeight
      opened={visible}
      icon="information"
      messageId={message}
      withHeading={false}
      onClick={onPopupClose}
      mobileFullScreen={false}
      iconClassName={styles.iconStyles}
      paperClassName={styles.paperStyles}
      buttonTitleId="submit.expiredToken"
      buttonClassName={styles.buttonStyles}
    />
  );
}

export default VideoCallEndPopup;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/VideoCallEndPopup/VideoCallEndPopup.jsx